module.exports = __webpack_public_path__ + "img/BINDI 3 RED.90d5e88.svg";